import { UsersActionTypes, UsersMutationTypes } from './types';
import { notifyError, notifySuccess, notifyDefaultError } from '../../helpers/notifications';

export const actions = {
    async [UsersActionTypes.GetUsers]({ commit }, { params }) {
        return new Promise((resolve, reject) => {
            this.$api.getUsers.get({
                params: { ...params },
            }).then((response) => {
                if (response && response.data && !response.data.error_message) {
                    commit(`${UsersMutationTypes.SetUsers}`, { users: response.data.data })
                    resolve({ data: response.data })
                } else if (response && response.data) {
                    notifyError({ title: response.data.error_message, errors: response.data.errors })
                    resolve(response.data)
                } else {
                    resolve()
                }
            })
            .catch((error) => {
                notifyDefaultError({ error })
                reject(error)
            })
        })
    },
    async [UsersActionTypes.AddUser](context, { data: userData } = {}) {
        try {
            const response = await this.$api.addUser.post({
                body: { ...userData }
            })
            const data = response && response.data
            if (!data) {
                notifyError({ title: 'Не удалось создать пользователя' })
                return
            }
            if (data.error_message) {
                notifyError({ title: data.error_message, errors: data.errors })
                return data
            }
            notifySuccess({ title: data.message })
            return data
        } catch (error) {
            notifyError({ title: 'Не удалось создать пользователя' })
        }
    },
    async [UsersActionTypes.EditUser]({ commit }, { id, value }) {
        try {
            const { data } = await this.$api.editUser.patch({ id, body: {
                ...value
            } })
            if (!data.error_message) {
                commit(UsersMutationTypes.SetChangedUser, {user: data.data})
                notifySuccess({ title: data.message })
            } else {
                notifyError({ title: data.error_message, errors: data.errors })
            }
        } catch (error) {
            notifyDefaultError({ error })
        }
    },
    async [UsersActionTypes.DeleteUser]({ commit }, { id }) {
        try {
            const { data } = await this.$api.deleteUser.delete({ 
                body: { id: id } 
            })
            if (!data.error_message) {
                commit(UsersMutationTypes.SetDeletedUser, { id })
                notifySuccess({ title: data.message })
            } else {
                notifyError({ title: data.error_message, errors: data.errors })
            }
        } catch (error) {
            notifyDefaultError({ error })
        }
    },
    async [UsersActionTypes.FindUser]({ commit }, { search, params }) {
        return new Promise((resolve, reject) => {
            this.$api.findUser.get({
                params: { search, ...params },
            }).then(({data}) => {
                if (!data.error_message) {
                    commit(`${UsersMutationTypes.SetUsers}`, { users: data.data })
                    // notifySuccess({ title: data.message })
                    resolve({data})
                } else {
                    notifyError({ title: data.error_message, errors: data.errors })
                    resolve(data.error_message)
                }
            })
            .catch((error) => {
                notifyDefaultError({ error })
                reject(error)
            })
        })
    },
}